<div class="container mx-auto px-4 py-8">
  <h1 class="text-4xl font-bold mb-8">Admin Dashboard</h1>

  <!-- Tabs -->
  <div class="mb-8 border-b border-gray-200">
    <nav class="flex space-x-8">
      <button 
        (click)="switchTab('bookings')"
        [class]="'py-4 px-1 border-b-2 font-medium text-sm transition ' + (activeTab === 'bookings' ? 'border-brand-accent text-brand-accent' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')">
        📅 Buchungen
      </button>
      <button 
        (click)="switchTab('equipment')"
        [class]="'py-4 px-1 border-b-2 font-medium text-sm transition ' + (activeTab === 'equipment' ? 'border-brand-accent text-brand-accent' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')">
        📺 Equipment
      </button>
      <button 
        (click)="switchTab('pricing-calculations')"
        [class]="'py-4 px-1 border-b-2 font-medium text-sm transition ' + (activeTab === 'pricing-calculations' ? 'border-brand-accent text-brand-accent' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')">
        💶 Kalkulationen
      </button>
    </nav>
  </div>

  <!-- Bookings Tab -->
  <div [ngClass]="{'hidden': activeTab !== 'bookings'}">
    <app-bookings-list 
      (selectBooking)="onSelectBooking($event)">
    </app-bookings-list>
  </div>

  <!-- Equipment Tab -->
  <div [ngClass]="{'hidden': activeTab !== 'equipment'}">
    <div class="bg-white rounded-lg shadow-lg p-6">
      <div class="mb-6 flex justify-between items-center">
        <h2 class="text-2xl font-bold">Equipment ({{ equipment.length }})</h2>
        <button 
          (click)="newEquipment()"
          routerLink="/admin/equipment"
          class="px-4 py-2 bg-brand-accent text-white rounded-lg hover:bg-brand-primary font-semibold transition">
          + Neues Equipment
        </button>
      </div>

      <div *ngIf="equipmentLoading" class="text-center text-gray-600 py-8">
        Laden...
      </div>

      <div *ngIf="!equipmentLoading && equipment.length === 0" class="text-center text-gray-600 py-8">
        Kein Equipment vorhanden
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div 
          *ngFor="let eq of equipment"
          class="border border-gray-200 rounded-lg p-4 hover:shadow-lg transition">
          <h3 class="font-bold text-lg mb-3">{{ eq.name }}</h3>
          
          <div class="space-y-2 text-sm mb-4">
            <p><span class="text-gray-600">Größe:</span> <span class="font-semibold">{{ eq.width }}m × {{ eq.height }}m</span></p>
            <p><span class="text-gray-600">Pixel Pitch:</span> <span class="font-semibold">{{ eq.pixelPitch }}mm</span></p>
            <p><span class="text-gray-600">Länge:</span> <span class="font-semibold">{{ eq.length }}m</span></p>
            <p><span class="text-gray-600">Transport:</span> <span class="font-semibold">{{ eq.deliveryWidth }}m × {{ eq.deliveryHeight }}m</span></p>
          </div>

          <div class="flex gap-2">
            <span [class]="'px-3 py-1 rounded-full text-sm font-semibold ' + (eq.isAvailable ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800')">
              {{ eq.isAvailable ? '✓ Verfügbar' : '✗ Nicht verfügbar' }}
            </span>
          </div>

          <div class="flex gap-2 mt-4">
            <button 
              (click)="editEquipment(eq.id!)"
              class="flex-1 px-3 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 font-semibold transition">
              Bearbeiten
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Price Calculations Tab -->
  <div [ngClass]="{'hidden': activeTab !== 'pricing-calculations'}">
    <app-price-calculations></app-price-calculations>
  </div>
</div>
